import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "price-info__old"
}
const _hoisted_3 = { class: "price-info__old-value" }
const _hoisted_4 = ["aria-current"]
const _hoisted_5 = { class: "price-info__value" }
const _hoisted_6 = { class: "price-info__value-euro" }
const _hoisted_7 = { class: "price-info__value-cent" }
const _hoisted_8 = { class: "price-info__currency" }
const _hoisted_9 = {
  key: 0,
  class: "price-info__asterisk"
}
const _hoisted_10 = {
  key: 1,
  class: "price-info__savedPercentage"
}
const _hoisted_11 = ["href", "innerHTML"]
const _hoisted_12 = { class: "price-info__unit" }
const _hoisted_13 = { class: "price-info__unit-text" }
const _hoisted_14 = {
  key: 0,
  class: "price-info__unit-price"
}
const _hoisted_15 = {
  key: 1,
  class: "price-info__tax-wrapper"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 1,
  class: "price-info__tax--article-number"
}

import {computed, ref} from 'vue';
  import type Price from '../../../bps/types/Price';
  import {t} from '@/bps/utilities/js/translations/translations';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'priceInfo',
  props: {
    value: {},
    showStar: { type: Boolean, default: false },
    showTax: { type: Boolean, default: false },
    showShippingIncluded: { type: Boolean, default: false },
    showSavedPercentage: { type: Boolean, default: false },
    shippingInfoUrl: { default: '' },
    foodSpecificationLink: { default: '' },
    articleNumber: { default: '' },
    showVolumeUnitText: { type: Boolean, default: false }
  },
  setup(__props: any) {

  const props = __props;

  const messageKey = ref<Record<string, string>>({
    deliveryInclShip: 'price.incl_vat_incl_ship',
    deliveryInclVat: 'price.incl_vat',
  });
  if (window.__productConfig && window.__productConfig.messageKey) {
    messageKey.value = window.__productConfig.messageKey;
  }

  const getUnitText = () => {
    let result = props.showVolumeUnitText
      ? `${t(`product.price.volumeUnit.${props.value.volumeUnit}`)} `
      : '';
    if (props.value.unitPrice) {
      if (props.value.packageSize) {
        result += props.value.packageSize
          .replace('.', ',')
          .replace('l', ' L');
      }
    }
    return result;
  };

  const splitCurrentValue = computed(() => {
    if (props.value.currency.toUpperCase() === 'CHF') {
      return props.value.currentValue
        .replace(props.value.currency, '')
        .split(/[:.]/);
    }
    return props.value.currentValue.split(/[:,]/);
  });

  const priceDot = props.value.currency.toUpperCase() === 'CHF' ? '.' : ',';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["price-info", {
      'price-info--reduction': _ctx.value.old,
      [`price-info--currency-${_ctx.value.currency}`]: true
    }]),
    "aria-label": _unref(t)('checkout.basket.position.header.price') + ' ' + _ctx.value.current
  }, [
    (_ctx.value.old)
      ? (_openBlock(), _createElementBlock("s", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.value.old), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    _cache[8] || (_cache[8] = _createTextVNode()),
    _createElementVNode("div", {
      class: "price-info__current",
      "aria-current": _ctx.value.old ? 'true' : null
    }, [
      _createElementVNode("span", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(splitCurrentValue.value[0]) + _toDisplayString(_unref(priceDot)), 1 /* TEXT */),
        _cache[0] || (_cache[0] = _createTextVNode()),
        _createElementVNode("small", _hoisted_7, _toDisplayString(splitCurrentValue.value[1]), 1 /* TEXT */)
      ]),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.value.currency), 1 /* TEXT */),
      _cache[2] || (_cache[2] = _createTextVNode()),
      (_ctx.showStar)
        ? (_openBlock(), _createElementBlock("sup", _hoisted_9, "\n        *\n      "))
        : _createCommentVNode("v-if", true),
      _cache[3] || (_cache[3] = _createTextVNode()),
      (_ctx.showSavedPercentage && _ctx.value.savedPercentage)
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "\n        -" + _toDisplayString(_ctx.value.savedPercentage) + "%\n      ", 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ], 8 /* PROPS */, _hoisted_4),
    _cache[9] || (_cache[9] = _createTextVNode()),
    _createElementVNode("div", {
      class: _normalizeClass(["price-info__info", {
        'price-info__info--inline': _ctx.foodSpecificationLink
      }])
    }, [
      (_ctx.foodSpecificationLink)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "price-info__food-specification-link",
            href: _ctx.foodSpecificationLink,
            innerHTML: _unref(t)('detail.product.characteristics')
          }, null, 8 /* PROPS */, _hoisted_11))
        : _createCommentVNode("v-if", true),
      _cache[6] || (_cache[6] = _createTextVNode()),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(getUnitText()), 1 /* TEXT */),
        _cache[5] || (_cache[5] = _createTextVNode()),
        (_ctx.value.unitPrice)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
              _createTextVNode("\n          (" + _toDisplayString(_ctx.value.unitPrice), 1 /* TEXT */),
              (_ctx.value.unit)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("/" + _toDisplayString(_ctx.value.unit), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _cache[4] || (_cache[4] = _createTextVNode(")\n        "))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */),
    _cache[10] || (_cache[10] = _createTextVNode()),
    (_ctx.showTax || _ctx.articleNumber.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (_ctx.showTax)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "price-info__tax",
                innerHTML: _unref(t)(_ctx.showShippingIncluded ? messageKey.value.deliveryInclShip : messageKey.value.deliveryInclVat, [_ctx.shippingInfoUrl])
              }, null, 8 /* PROPS */, _hoisted_16))
            : _createCommentVNode("v-if", true),
          _cache[7] || (_cache[7] = _createTextVNode()),
          (_ctx.articleNumber.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(t)('checkout.basket.position.productNr')) + " " + _toDisplayString(_ctx.articleNumber), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})